import linkedin from "../../../src/assets/images/linkedin2.png"
import github from "../../../src/assets/images/github.png"
import bastian from "../../../src/assets/fotos/bastian.jpeg"
import tomas from "../../../src/assets/fotos/tomas.jpeg"
import ale from "../../../src/assets/fotos/ale.JPG"
import abril from "../../../src/assets/fotos/abril.jpg"
import uli from "../../assets/fotos/uli.jpg"
import bruno from "../../../src/assets/fotos/bruno.jpg"
import luis from "../../../src/assets/fotos/luis.jpg"

const dataNosotros = [
    {
        imagen: bastian,
        displayName: "Sebastian Murillo Alzate",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/bastianalzate"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/bastianalzate/"
            }
        ]
    },
    {
        imagen: ale,
        displayName: "Ale",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/AleEspinozama"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/alejandra-espinoza-lezama/"
            }
        ]
    },
    {
        imagen: tomas,
        displayName: "Tomas",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/tomasgoyret"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/tomasgoyret/"
            }
        ]
    },
    {
        imagen: uli,
        displayName: "Uli",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/UliVargas"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/ulisesvaf"
            }
        ]
    },
    {
        imagen: "",
        displayName: "Santi",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/bastianalzate"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/bastianalzate/"
            }
        ]
    },
    {
        imagen: abril,
        displayName: "Abril",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/MaarGoesGil"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/abrilgil"
            }
        ]
    },
    {
        imagen: luis,
        displayName: "Luis",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/LuisEA97"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/luis-aguilar-dev"
            }
        ]
    },
    {
        imagen: bruno,
        displayName: "Bruno",
        titulo: "Full Stack Developer",
        redes: [
            {
                name: "github",
                icon: github,
                url: "https://github.com/bruno8a10"
            },
            {
                name: "linkedin",
                icon: linkedin,
                url: "https://www.linkedin.com/in/bruno-ochoa-87666a1b6/"
            }
        ]
    },
]

export default dataNosotros;
